var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-slider',{attrs:{"id":"test","default-value":30,"disabled":_vm.disabled}}),_c('a-slider',{attrs:{"range":"","default-value":[20, 50],"disabled":_vm.disabled}}),_vm._v(" Disabled: "),_c('a-switch',{attrs:{"size":"small","checked":_vm.disabled},on:{"change":_vm.handleDisabledChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }